import { twMerge } from "tailwind-merge";
import { DataListProps } from "common/pages/console/-components/ConsoleTable";
import speaker from "assets/common/support/notice_speaker.png";

type TableProps = {
    thead: {
        title: string;
        width: string;
        key: string;
        className?: string;
        onClick?: (value: any, row: DataListProps, rowIndex: number) => void;
        content?: (row: DataListProps, rowIndex: number) => void;
    }[];
    tbody: DataListProps[];
    className?: string;
    currentPage?: number;
    totalCount?: number;
};

export default function Table({ thead, tbody, className, currentPage, totalCount }: TableProps) {
    const figureStyle = twMerge(`overflow-x-auto`, className);
    return (
        <figure className={figureStyle}>
            <table className="min-w-[700px] w-full border-t border-t-[3px] border-t-[#999999] border-b border-b-[1px] border-b-[#dddddd] table-fixed">
                <colgroup>
                    <col width="10%" />
                    {thead.map((th, index) => {
                        return <col key={index} width={th.width} />;
                    })}
                </colgroup>

                <thead>
                    <tr className="border-b border-b-[1px] border-b-[#dddddd]">
                        <th scope="col" className="font-[500] py-[15px] text-[#666666]">
                            NO
                        </th>
                        {thead.map((th, index) => {
                            return (
                                <th
                                    key={index}
                                    scope="col"
                                    className="font-[500] py-[15px] text-[#666666] relative before:content-[''] before:absolute before:w-[1px] before:h-[22px] before:top-1/2 before:-translate-y-1/2 before:left-0 before:bg-[#dddddd]"
                                >
                                    <span className="txt">{th.title}</span>
                                </th>
                            );
                        })}
                    </tr>
                </thead>
                <tbody>
                    {tbody.length === 0 ? (
                        <tr>
                            <td colSpan={thead.length + 1} className="text-center py-[100px]">
                                등록된 게시글이 없습니다.
                            </td>
                        </tr>
                    ) : (
                        <>
                            {tbody.map((tb, index) => {
                                let idx;
                                if (totalCount && currentPage) {
                                    idx = totalCount - (currentPage - 1) * 10 - index;
                                }

                                return (
                                    <tr key={tb.list_no ?? index} className="border-b border-[#dddddd]">
                                        <td className="text-center align-middle py-[16px]">
                                            {tb.notice === 1 ? (
                                                <figure className="h-[24px] w-[24px] mx-auto flex items-center justify-center">
                                                    <img src={speaker} alt="" />
                                                </figure>
                                            ) : (
                                                <p className="truncate">{idx}</p>
                                            )}
                                        </td>
                                        {thead.map((th, idx) => (
                                            <td
                                                key={idx}
                                                className={twMerge("py-[13px]", th.className)}
                                                onClick={() => th.onClick?.(tb[th.key as keyof DataListProps], tb, index)}
                                            >
                                                {typeof th.content === "function"
                                                    ? th.content(tb, index)
                                                    : tb[th.key as keyof DataListProps]}
                                            </td>
                                        ))}
                                    </tr>
                                );
                            })}
                        </>
                    )}
                </tbody>
            </table>
        </figure>
    );
}
